export default "__VITE_ASSET__B$auCScc__"